import { Linkedin, Instagram, Twitter } from "lucide-react";
import { Link } from "react-router-dom";

const NAV = [
  { label: "Services", id: "services" },
  { label: "Approach", id: "approach" },
  { label: "About", id: "about" },
  { label: "Contact", id: "contact" },
];

const SOCIALS = [
  { icon: Linkedin, label: "linkedin", href: "https://www.linkedin.com/in/qauntum-international-075a10429" },
  { icon: Instagram, label: "instagram", href: "https://www.instagram.com/qauntuminternational/" },
  { icon: Twitter, label: "twitter", href: "https://x.com/QauntumInterna" },
];

export const Footer = () => {
  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <footer className="px-6 md:px-12 lg:px-24 pt-20 pb-10 bg-quantum-bg border-t border-white/10" data-testid="site-footer">
      <div className="flex flex-col lg:flex-row justify-between gap-12 mb-16">
        <div className="max-w-sm">
          <p className="font-serif-q text-2xl text-quantum-text mb-4">Qauntum International</p>
          <p className="text-quantum-muted leading-relaxed">
            A house of services for ambitious brands and individuals — from the heart of Business Bay, Dubai.
          </p>
        </div>
        <div className="flex gap-16 md:gap-24">
          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-quantum-gold mb-5">Navigate</p>
            <ul className="space-y-3">
              {NAV.map((n) => (
                <li key={n.id}>
                  <button
                    onClick={() => scrollTo(n.id)}
                    data-testid={`footer-nav-${n.id}`}
                    className="text-quantum-muted hover:text-quantum-text transition-colors"
                  >
                    {n.label}
                  </button>
                </li>
              ))}
              <li>
                <Link
                  to="/brand"
                  data-testid="footer-nav-brand"
                  className="text-quantum-muted hover:text-quantum-gold transition-colors"
                >
                  Brand Kit
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-quantum-gold mb-5">Legal</p>
            <ul className="space-y-3">
              <li>
                <Link to="/privacy" data-testid="footer-link-privacy" className="text-quantum-muted hover:text-quantum-gold transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" data-testid="footer-link-terms" className="text-quantum-muted hover:text-quantum-gold transition-colors">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to="/cookies" data-testid="footer-link-cookies" className="text-quantum-muted hover:text-quantum-gold transition-colors">
                  Cookie Policy
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-quantum-gold mb-5">Contact</p>
            <ul className="space-y-3 text-quantum-muted">
              <li>info@qauntuminternational.com</li>
              <li>+971 4 834 2593</li>
              <li>107, Churchill Tower</li>
              <li>Business Bay, Dubai, UAE</li>
              <li className="pt-2 text-quantum-muted/80">Mon – Fri · 10.00 – 5.00</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="relative overflow-hidden">
        <h2 className="font-serif-q text-[19vw] leading-none tracking-tighter font-light text-quantum-text/90 select-none whitespace-nowrap">
          QAUNTUM
        </h2>
      </div>

      <div className="flex flex-col md:flex-row items-center justify-between gap-6 pt-8 border-t border-white/10 mt-4">
        <p className="text-sm text-quantum-muted">
          © {new Date().getFullYear()} Qauntum International. All rights reserved.
        </p>
        <div className="flex gap-4">
          {SOCIALS.map(({ icon: Icon, label, href }) => (
            <a
              key={label}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`social-${label}`}
              aria-label={label}
              className="grid place-items-center h-10 w-10 rounded-full border border-white/15 text-quantum-muted hover:text-quantum-gold hover:border-quantum-gold transition-colors"
            >
              <Icon size={16} />
            </a>
          ))}
        </div>
      </div>
    </footer>
  );
};
